import FieldsPayStubEarningsStatement from './FieldsPayStubEarningsStatement'

export default FieldsPayStubEarningsStatement
